export const COPILOT_HOME_PRESENTATION_ACTION =
  'SET_COPILOT_HOME_PRESENTATION' as const;

export type HomeCopilotPresentation = 'compact' | 'focused' | 'sidebar';

export const setCopilotHomePresentation = (
  presentation: HomeCopilotPresentation
) => ({
  type: COPILOT_HOME_PRESENTATION_ACTION,
  presentation
});
